// For a symmetric hexagon the bias is tiny for an axis-aligned 8 m SQUARE it is a real ~0.7 m
// (~cell/10) shift toward the first corner — and this centroid feeds adjacency-pitch estimation
// hex→zone assignment, zone-label anchors, the accuracy RMS, and the sampling-point candidates, so
// the bias must go.
export function ringCentroid(ring: ReadonlyArray<ReadonlyArray<number>>): {
  lng: number;
  lat: number;
} {
  const m = ring.length;
  const closed =
    m > 1 && ring[0][0] === ring[m - 1][0] && ring[0][1] === ring[m - 1][1];
  const n = (closed ? m - 1 : m) || 1;
  let lng = 0;
  let lat = 0;
  for (let i = 0; i < n; i++) {
    lng += ring[i][0];
    lat += ring[i][1];
  }
  return { lng: lng / n, lat: lat / n };
}

// Centroid of a Polygon/MultiPolygon's OUTER ring (first part for MultiPolygon). null when there is no ring.
export function geomCentroid(
  g?: GeoJSON.Geometry,
): { lng: number; lat: number } | null {
  const ring =
    g?.type === "Polygon"
      ? (g.coordinates[0] as number[][])
      : g?.type === "MultiPolygon"
        ? (g.coordinates[0]?.[0] as number[][] | undefined)
        : undefined;
  if (!ring?.length) return null;
  return ringCentroid(ring);
}
